export default ($) => {
  // search & dealer panels
  $('.search_icon').on('click', function (e) {
    e.preventDefault();
    $('.desktop-search-panel').fadeToggle(300);
    $('.desktop-search-panel input').focus();

    $('.mobile-menu').removeClass('opened');
    $('.hamburger').removeClass('is-active');
  });

  $('header .additional-menu .additional-menu-dealer').on('click', function (e) {
    e.preventDefault();
    $('.desktop-dealer-panel').fadeToggle(300);
    $('.desktop-dealer-panel input').focus();

    $('.mobile-menu').removeClass('opened');
    $('.hamburger').removeClass('is-active');
  });

  $('.desktop-search-panel__close, .desktop-dealer-panel__close').on('click', function (e) {
    e.preventDefault();
    $(this).parent().parent().fadeOut(300);
  });

  $('.hamburger').on('click', function (e) {
    e.preventDefault();
    $('.mobile-menu').toggleClass('opened');
    $(this).toggleClass('is-active');

    $('.desktop-search-panel').fadeOut(300);
    $('.desktop-dealer-panel').fadeOut(300);

    $('.has-submenu > a').each((index, element) => {
      $(element).parent().addClass('is-active');
      $(element).next().addClass('is-active');
    });

    $('.mobile-menu-header > a').each((index, element) =>  {
      $(element).parent().parent().removeClass('is-active');
      $(element).parent().parent().parent().removeClass('is-active');
    });
  });

  $('.mobile-menu .dark-blur').on('click', function (e) {
    e.preventDefault();
    $('.mobile-menu').removeClass('opened');
    $('.hamburger').removeClass('is-active');
  });

  $('body').on( 'click', function(e) {
    if ($(e.target).closest(".search_icon").length)
        return;

    if ($(e.target).closest(".desktop-search-panel").length)
        return;

    if ($(e.target).closest('header .additional-menu .additional-menu-dealer').length)
        return;

    if ($(e.target).closest(".desktop-dealer-panel").length)
        return;

      $('.desktop-search-panel').fadeOut(300);
      $('.desktop-dealer-panel').fadeOut(300);
  });

  $(window).on('resize load', function() {
    if ($(window).width() <= '767.9') {
      // $('div.mobile-panel > div > div.mobile-panel__menu.loaded > ul > li:nth-child(2) > ul > li:nth-child(8) > ul > li:nth-child(9)').hide();
    } else {
      $('[data-hover-load="view-all-accessories-top"]').hide();
      $('[data-hover-load="view-all-accessories-bottom"]').show();
      $('[data-hover-load="view-all-tools-top"]').hide();
      $('[data-hover-load="view-all-tools-bottom"]').show();
      $('[data-hover-load="view-all-water-care-top"]').hide();
      $('[data-hover-load="view-all-water-care-bottom"]').show();
    }
  });

  $('#clear-search').click(() => {
    $('#search-field').val('');
  });

  $('#clear-zip-code').click(() => {
    $('#zip-code-field').val('');
  });

  var header_height = $('.header').outerHeight();
  $(window).on('load', function() {
    if( $('.notification-bar').length ) {
      var pos_header = $('.header').offset().top;
      var pos_header_new = header_height + parseInt(pos_header);
      $('.mobile-menu').css('top', pos_header_new+'px');
    }
  });

  $(window).on('scroll resize', function() {
    var height_bar, pos_window_top, indent;
    var mobile_menu = $('.mobile-menu');
    pos_window_top = $(window).scrollTop();
    if( pos_window_top <= header_height ) {
      if( $('.notification-bar .toast-body').length ) {
        height_bar = $('.notification-bar').outerHeight();
        indent = parseInt( height_bar ) - parseInt( pos_window_top ) + parseInt( header_height );
        mobile_menu.css('top', indent+'px');
      } else {
        mobile_menu.css('top', header_height+'px');
      }
    } else {
      mobile_menu.css('top', header_height+'px');
    }
  });

}
